<script lang="ts" setup>
import { computed } from 'vue';

import { useWebViewStore } from '@nora-monorepo/ui-shared';

import CompassRose from '#nora-ui/map/components/controls/CompassRose.vue';
import FileOverlay from '#nora-ui/map/components/controls/FileOverlay.vue';
import MapCenterControl from '#nora-ui/map/components/controls/MapCenterControl.vue';
import MapSearch from '#nora-ui/map/components/controls/MapSearch.vue';
import MapDrawToolControls from '#nora-ui/map/components/drawtools/MapDrawToolControls.vue';
import MapNavigationRail from '#nora-ui/map/components/navigation-rail/MapNavigationRail.vue';
import OverlayMenu from '#nora-ui/map/components/overlay-menu/OverlayMenu.vue';
import { useMapStore } from '#nora-ui/map/stores/map-store';

interface MapControlsProps {
  mapId: string;
}

const props = defineProps<MapControlsProps>();

const mapStore = useMapStore();
const webViewStore = useWebViewStore();

const map = mapStore.getMapByIdOrThrow(props.mapId);
const rotation = computed(() => map.ref.rotation);
const showCompassRose = computed(() => map.ref.rotation !== 0 || map.ref.isInHeadingUpMode);

function handleResetMapRotation() {
  map.setRotation(0);
  map.ref.setHeadingUpMode(false);
}
</script>

<template>
  <OverlayMenu :map-id="map.ref.id" />
  <div class="absolute z-40 pointer-events-auto bottom-5 left-5">
    <div class="flex flex-col gap-y-5">
      <MapDrawToolControls
        v-show="!webViewStore.isWebView || !map.contextMenu.isOpen.value"
        :map-id="map.ref.id"
      />
      <div class="flex items-center justify-start gap-1 h-12">
        <MapCenterControl :map-id="map.ref.id" />
        <button
          class="cursor-pointer"
          @click="handleResetMapRotation"
        >
          <CompassRose
            :rotation="rotation"
            :show="showCompassRose"
          />
        </button>
      </div>
    </div>
  </div>
  <MapSearch
    v-if="!map.state.draw.drawLayerMenuOpen"
    :map-id="map.ref.id"
  />
  <MapNavigationRail
    v-if="!webViewStore.isWebView"
    :map-id="map.ref.id"
  />
  <FileOverlay
    v-if="map.state.file.selectedFile"
    class="absolute z-40 bottom-5 left-1/2 -translate-x-1/2"
    :map-id="map.ref.id"
  />
</template>
